import autoBind from 'auto-bind';
import { Component } from 'react';
import Log from '../common/util/log';
import { Backend } from '../controller/backend';
import { FormBloc } from '../controller/form_bloc';
import { AppDep, BlocProvider } from '../provider';
import GuestPageLayout from './../../src/layout/GuestPageLayout';
import { User } from '../controller/do';
import { GlobalContext } from '../common/modal_boundary';
import { ForgetPassForm } from './formComponent/ForgetPassForm';
import { Navigation } from '../controller';

const TAG = 'forgot-pass-page';

class Bloc {
	public formBloc: FormBloc<{ email: string }>;
	private _api: Backend.Api;
	public navigation: Navigation.Bloc;

	constructor(appDep: AppDep) {
		autoBind(this);
		this.formBloc = new FormBloc({ email: User.Constraints.email }, this.onValidated);
		this._api = appDep.api;
		this.navigation = appDep.navigation;
	}

	@GlobalContext.handlErrorAsModal()
	@GlobalContext.handleSuccessAsModal(
		Promise,
		'Request to reset password was made successfully. Please check your email inbox for further instructions.'
	)
	async onValidated(value: { email: string }): Promise<void> {
		Log.d(TAG, 'inside onValidated', value);
		await this._api.requestPasswordReset(value.email);
	}
}

export default class ForgetPassPage extends Component {
	render() {
		return (
			<>
				<BlocProvider
					create={(appDep: AppDep) => new Bloc(appDep)}
					builder={(bloc: Bloc) => {
						return (
							<>
								<GuestPageLayout>
									<div className="login-form">
										<div>
											<h1 className="ml-2" style={{ color: '#DC2E20' }}>
												Request Password Reset
											</h1>
											<ForgetPassForm navigation={bloc.navigation} formBloc={bloc.formBloc} />
										</div>
									</div>
								</GuestPageLayout>
							</>
						);
					}}
				/>
			</>
		);
	}
}
